export enum Progress {
    Unplanned = "",
    Planned = " planned ",
    GaveALesson = " was given a lesson on ",
    WorkingOnIt = " is working on ",
    Mastered = " mastered ",
}

export type ProgressSymbol = "" | " " | "∕" | "Λ" | "△";